import React from 'react';
import axios from 'axios';
import { urlAPI_Current } from './config';
import styles from './styles/errorBoundary.module.css';
import { jwtDecode } from 'jwt-decode';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const token = localStorage.getItem('authToken');
    const decoded = jwtDecode(token);
    const userId = decoded.userId;

    const logData = {
      tela: window.location.href,
      erro: `${error.toString()} - ${errorInfo.componentStack}`,
      idUser: userId
    };

    axios.post(`${urlAPI_Current}/saveLogError`, logData)
      .then(response => {
        console.log("Erro enviado com sucesso:", response.data);
      })
      .catch(error => {
        console.error("Erro ao enviar o log:", error);
      });
  }

  handleBack = () => {
    window.history.back();
    window.location.reload();
  };

  handleBackHome = () => {
    window.open(
      "https://www.evoktm.com.br/evokchat/build/#/login",
      "_self"
    );
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorContainer}>
          <h1>Ocorreu um erro inesperado.</h1>
          <p>Lamentamos muito! Tente novamente mais tarde.</p>

          <p>Código de erro enviado para análise</p>
          <button onClick={this.handleBack} className={styles.backButton}>
            Tentar Novamente
          </button>
          <button onClick={this.handleBackHome} className={styles.backButton}>
            Ir para página inical
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
